import { useQuery, useQueryClient } from 'react-query';

import { getV2ApiCompanyIdAccountingIntegrationsSyncSettings } from 'src/client/spendesk-api';
import { type GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsResponseOK } from 'src/client/spendesk-api-types';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

import { useHasMapSync } from '../hooks/useHasMapSync';

type Unpacked<T> = T extends (infer U)[] ? U : T;
export type SyncSetting =
  Unpacked<GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsResponseOK>;

export const useGetSyncSettings = (fieldId?: string | undefined) => {
  const companyId = useCompanyId();
  const isEnabled = useHasMapSync();
  const { isLoading, data } = useQuery({
    queryKey: ['syncSettings', companyId],
    enabled: isEnabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response =
        await getV2ApiCompanyIdAccountingIntegrationsSyncSettings({
          path: {
            companyId,
          },
          ...(fieldId ? { query: { fieldId } } : {}),
        });

      if (response.statusCode === 200) {
        return response.body.map((setting): SyncSetting => setting);
      }

      return [];
    },
  });

  return {
    isLoading,
    syncSettings: data,
  };
};

export const useInvalidateSyncSettingsQuery = () => {
  const queryClient = useQueryClient();
  const companyId = useCompanyId();
  return () => {
    queryClient.invalidateQueries({
      queryKey: ['syncSettings', companyId],
    });
  };
};
